// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__3ZrPk","title":"ClientReferral_title__23r_d","itemText":"ClientReferral_itemText__2rBz9"};